var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", { staticClass: "center" }, [_vm._v("Meine Wunschausbildung")]),
      _vm._v(" "),
      [
        _c(
          "div",
          { staticClass: "card", attrs: { role: "tablist" } },
          _vm._l(_vm.expectedJobList, function (item, index) {
            return _c(
              "b-card",
              { key: item.id, staticClass: "mb-1", attrs: { "no-body": "" } },
              [
                _c(
                  "b-card-header",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle",
                        value: "accordion-" + index,
                        expression: "'accordion-' + index",
                      },
                    ],
                    staticClass: "card-header",
                    attrs: { "header-tag": "header", role: "tab" },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(item.headline) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    attrs: {
                      id: "accordion-" + index,
                      accordion: "my-accordion",
                      role: "tabpanel",
                    },
                  },
                  [
                    _c("b-card-body", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-12 control-label",
                            attrs: { for: "textinput" },
                          },
                          [_vm._v("Gewünschter Ausbildungsberuf")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.job.name,
                                expression: "item.job.name",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "newJob",
                              list: "jobList",
                            },
                            domProps: { value: item.job.name },
                            on: {
                              change: function ($event) {
                                return _vm.setDirty(index)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(item.job, "name", $event.target.value)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "datalist",
                            { attrs: { id: "jobList" } },
                            _vm._l(_vm.jobList, function (item) {
                              return _c("option", [_vm._v(_vm._s(item.name))])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          !_vm.isValidJobName
                            ? _c(
                                "label",
                                {
                                  staticClass: "control-label text-danger",
                                  attrs: {
                                    id: "invalidJobName",
                                    for: "textinput",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Dieser Ausbildungsberuf existiert nicht. Bitte wähle einen\n                  gültigen Beruf aus.\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "m-2 btn btn-outline-primary",
                              attrs: { type: "button", id: "btnResetCity" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetExpectedJob(index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  Ausbildungsberuf leeren\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-12 control-label",
                            attrs: { for: "textinput" },
                          },
                          [_vm._v("Hier würde ich am liebsten arbeiten")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-12 control-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.plz.detailed,
                                expression: "item.plz.detailed",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "joblocation",
                              list: "cityList",
                            },
                            domProps: { value: item.plz.detailed },
                            on: {
                              change: function ($event) {
                                return _vm.setDirty(index)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  item.plz,
                                  "detailed",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "datalist",
                            { attrs: { id: "cityList" } },
                            _vm._l(_vm.cityList, function (item) {
                              return _c("option", { key: item.zip }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.plz) +
                                    " - " +
                                    _vm._s(item.stadt) +
                                    "\n                  "
                                ),
                              ])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          !_vm.isValidLocation
                            ? _c(
                                "label",
                                {
                                  staticClass: "control-label text-danger",
                                  attrs: {
                                    id: "invalidLocation",
                                    for: "textinput",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Die Postleitzahl/Stadt-Kombination ist nicht gültig. Bitte\n                  gib eine gültige Kombination aus der Liste an.\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "m-2 btn btn-outline-primary",
                              attrs: { type: "button", id: "btnResetCity" },
                              on: {
                                click: function ($event) {
                                  return _vm.resetJobLocation(index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  Ort/PLZ leeren\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-sm-12 control-label",
                            attrs: { for: "textinput" },
                          },
                          [_vm._v("So viele Kilometer weg sind auch ok")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-12" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.perimeter,
                                expression: "item.perimeter",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", id: "workDist" },
                            domProps: { value: item.perimeter },
                            on: {
                              change: function ($event) {
                                return _vm.setDirty(index)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(item, "perimeter", $event.target.value)
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-offset-2 col-sm-12" },
                          [
                            _c("div", { staticClass: "text-center" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "m-2 btn btn-outline-primary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteExpectedJob(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    Eintrag löschen\n                  "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "m-2 btn btn-primary",
                                  attrs: {
                                    type: "button",
                                    disabled: !_vm.isDirty,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateExpectedJob(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    Eintrag speichern\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _c(
              "router-link",
              {
                staticClass: "m-2 btn btn-outline-primary",
                attrs: { to: "/signedin", id: "buttonBack" },
              },
              [_vm._v("Zurück")]
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }